 import {createRoot} from "react-dom/client";
import App from './App';
import './static/fonts/font.css';
const container:any = document.getElementById('root');
const root = createRoot(container);
root.render(<App/>);